import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';

import { renderSelectedCard } from 'utils';

import { styles } from './styles';

const CardOnFileSelect = ({ cardsOnFile }) => {
	const { control } = useFormContext();

	return (
		<Controller
			name="card_on_file"
			control={control}
			render={({ field, fieldState: { error } }) => (
				<FormControl variant="filled" error={Boolean(error)} sx={styles.field}>
					<InputLabel id="select-member-type" required>
						Select Card on File
					</InputLabel>
					<Select
						labelId="select-member-type"
						id="demo-simple-select-filled"
						{...field}
						renderValue={renderSelectedCard}
					>
						{cardsOnFile.map(card => {
							return (
								<MenuItem key={card.id} value={card}>
									{`${card.card_brand} ${card.last_4}`}
								</MenuItem>
							);
						})}
					</Select>
					{Boolean(error?.message) && <Box sx={styles.error}>{error.message}</Box>}
				</FormControl>
			)}
		/>
	);
};

export default CardOnFileSelect;
